import { __assign } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@mui/material";
import { useRef, useState } from "react";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import { useStoreFileViewerContext } from "../../hooks/context";
import { uploadFiles } from "../UploadPopover/hooks";
var CreateNewFileButton = function (_a) {
    var ButtonProps = _a.ButtonProps, onClose = _a.onClose;
    var _b = useStoreFileViewerContext(), apiRef = _b.apiRef, reload = _b.reload, parent = _b.parent;
    var inputRef = useRef();
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var handleClose = function () {
        setOpen(false);
        onClose();
    };
    return (_jsxs(_Fragment, { children: [_jsx("input", { 
                // @ts-ignore
                ref: inputRef, style: { display: "none" }, type: "file", onChange: function (e) {
                    if (e.target.files) {
                        uploadFiles(e.target.files);
                        handleClose();
                    }
                } }), _jsx(Button, __assign({ variant: "text", disabled: loading }, ButtonProps, { startIcon: _jsx(FileOpenIcon, { fontSize: "small" }), onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, children: "File" }))] }));
};
export default CreateNewFileButton;
